import React, {useContext, useEffect, useRef, useState} from "react";
import AuthContext from "../utilis/contexts/AuthContext";
import Texts from "../utilis/defaults/Text";
import {Button, Divider} from "antd";
// @ts-ignore
import {Line} from '@ant-design/charts';
import Api from "../utilis/api/service";
import Urls from "../utilis/api/Urls";
import {AxiosError, AxiosResponse} from "axios";
import LocalStorage from "../utilis/tools/LocalStorage";
import branchInfo from "../utilis/models/branchInfo";
import AppContext from "../utilis/contexts/AppContext";
import {useNavigate, Link, useOutletContext} from "react-router-dom";
import {PlusOutlined, FileDoneOutlined} from "@ant-design/icons";
import ReactApexChart from 'react-apexcharts';

const Dashboard = () => {

    const navigate = useNavigate();
    const {openModal} = useOutletContext<any>();
    const authContext = useContext(AuthContext);
    const appContext = useContext(AppContext);
    const submitRef = useRef<HTMLButtonElement>(null)
    const [state,setState]=useState({
        Token:'',
        Language:'',
        SendURL:'',
    })
    const handlePayment=()=>{
        appContext.handleLoading(true)
        Api.post(Urls.BillPayment, {
            Cellphone: authContext.user.cellphone,
            BillId:authContext.currentBranchInfo.bill_id,
            PayId:authContext.currentBranchInfo.pay_id,
        }, {
            headers: {
                "Authorization": authContext.Token.tokenType + " " + authContext.Token.accessToken
            }
        }).then((response: AxiosResponse) => {

           if(response.data.Status===0){
               setState(response.data.Data)
           }


      /*      let myWindow = window.open("", "_self", );
            // @ts-ignore
            myWindow.document.write(response.data);
*/

        }).catch((e: AxiosError) => {

        }).finally(() => {
            appContext.handleLoading(false)
        })

    }
    useEffect(()=>{
        if(state.SendURL!==''){

            appContext.handleLoading(true)
            if(submitRef.current){

                submitRef.current.click();
            }
        }
    },[state])
    const options: ApexCharts.ApexOptions = {
        chart: {
            type: 'line',
            toolbar: {
                show: false
            },

        }
    }
    const series = [{
        name: 'امسال',
        data: [+authContext.currentBranchInfo.average_current_year_period1, +authContext.currentBranchInfo.average_current_year_period2, +authContext.currentBranchInfo.average_current_year_period3, +authContext.currentBranchInfo.average_current_year_period4, +authContext.currentBranchInfo.average_current_year_period5, +authContext.currentBranchInfo.average_current_year_period6]
    }, {
        name: 'سال گذشته',
        data: [+authContext.currentBranchInfo.average_last_year_period1, +authContext.currentBranchInfo.average_last_year_period2, +authContext.currentBranchInfo.average_last_year_period3, +authContext.currentBranchInfo.average_last_year_period4, +authContext.currentBranchInfo.average_last_year_period5, +authContext.currentBranchInfo.average_last_year_period6]
    }]
    const handleBranchInfo = (fileNum: string) => {

        appContext.handleLoading(true)
        Api.post(Urls.getBranchInfo, {
            Cellphone: authContext.user.cellphone,
            FileNumber: fileNum
        }, {
            headers: {
                "Authorization": authContext.Token.tokenType + " " + authContext.Token.accessToken
            }
        }).then((response: AxiosResponse) => {

            const {data} = response;
            const {Data, Status} = data;
            const {branches, branch_info} = Data;
            if (Status === 0) {
                LocalStorage.setFileNumber(fileNum);
                authContext.handleCurrentFileNumber(fileNum)
                authContext.handleCurrentBranchInfo(Object.keys(branch_info).length === 0 ? new branchInfo() : branch_info)
                authContext.handleBranches(branches)
                navigate('/panel')
            }

        }).catch((e: AxiosError) => {

        }).finally(() => {
            appContext.handleLoading(false)
        })

    }
    if (!authContext.currentFileNumber) {
        return <>
            <Divider><h4 className="text-xl">اشتراک خود را انتخاب کنید</h4></Divider>


            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5">

                <div
                    className="bg-white m-2 text-primary  border opacity-90 duration-200 cursor-pointer hover:opacity-100  shadow-sm rounded-lg p-3 flex justify-center items-center"
                    onClick={openModal}>
                    <span>افزودن اشتراک </span>
                    <PlusOutlined/></div>
                {
                    authContext.branches.map((branch: any, index) => <div
                        className="bg-primary m-2 opacity-90 duration-200 cursor-pointer hover:opacity-100 text-white shadow-sm rounded-lg p-3 flex justify-center items-center"
                        onClick={() => handleBranchInfo(branch.file_number)} key={index + "new-branch"}>
                        <span>{branch.file_number}</span>
                    </div>)
                }
            </div>
        </>
    }
    if (authContext.currentBranchInfo && authContext.currentFileNumber) {
        // @ts-ignore
        return <div>
            <form id='data_form'  method='post' action={state.SendURL}>
                <input type='hidden' name='token' value={state.Token} />
                <input type='hidden' name='language' value={state.Language} />
                <button className="hidden" ref={submitRef} type="submit">submit</button>
            </form>
            <div className="w-full p-2">
                <div className="bg-primary flex flex-col justify-center items-center min-h-[150px] rounded-lg p-5">
                    <h3 className="font-bold text-white text-2xl">{authContext.currentBranchInfo.name}</h3>
                    <span className="text-white">{authContext.currentFileNumber}</span>

                </div>
            </div>
            <div className="flex justify-center flex-wrap">

                <Link to={'/billView'} className="w-full lg:w-3/12 p-2">
                    <div
                        className="bg-green-400 text-white flex flex-col justify-center items-center min-h-[150px] rounded-lg p-5">
                        <div className="flex justify-center flex-col">
                            <FileDoneOutlined className="text-4xl text-white mb" size={100}/>
                            <span className="text-white">مشاهده قبض</span>
                        </div>
                    </div>
                </Link>
                <div className="w-full lg:w-3/12 p-2">
                    <div className="bg-gray-100 flex flex-col justify-center items-center min-h-[150px] rounded-lg p-5">
                        <div className="flex justify-center flex-col">
                            <span className="block mb-2 flex flex-wrap  flex-col justify-center items-center mx-2">

                                <span
                                    className="text-center  font-bold  text-center">میزان  بدهی آخرین دوره  </span>
                                <span
                                    className="text-sm">{authContext.currentBranchInfo.amount + Texts.moneyUnit}</span></span>
                            <Button onClick={handlePayment} type="ghost" color="ghost" disabled={+authContext.currentBranchInfo.amount<=0}
                                    className="rounded-lg mt-1 mx-2">پرداخت</Button></div>
                    </div>
                </div>
                <div className="w-full lg:w-6/12 p-2">
                    <div
                        className="bg-gray-100 grid grid-cols-1 md:grid-cols-2 flex flex-col justify-center items-center min-h-[150px] rounded-lg p-5">
                        <span className="block mb-2 mx-2"><strong
                            className="">شهر :  </strong><span>{authContext.currentBranchInfo.city}</span></span>
                        <span className="block mb-2 mx-2"><strong
                            className="">نوع کاربری :  </strong><span>{authContext.currentBranchInfo.account_type}</span></span>
                        <span className="block mb-2 mx-2"><strong
                            className="">تعداد واحد :  </strong><span>{authContext.currentBranchInfo.units_number}</span></span>
                        <span className="block mb-2 mx-2"><strong
                            className="">شماره پرونده :  </strong><span>{authContext.currentFileNumber}</span></span>
                    </div>
                </div>
                <div dir="rtl" className="w-full">
                    <Divider><h3 className="font-bold text-primary">نمودار روند مصرف ( متر مکعب)</h3></Divider>
                </div>
                <div className="w-full overflow-hidden">
                    <ReactApexChart options={options} series={series} type="line" height={350}/>
                </div>
            </div>

        </div>
    }
    return <></>

}
export default Dashboard;